module.exports = __webpack_public_path__ + "static/media/panorama-cover.41f15c88.jpg";